import { SET_JOB_ATTRIBUTE } from 'vx/mutations'
import { find, isObject } from 'lodash'

export default {
  computed: {
    user: {
      get () {
        return this.job.user_id
      },

      set (value) {
        value = isObject(value) ? value.id : value

        this[SET_JOB_ATTRIBUTE]({ attribute: 'user_id', value })
      }
    },

    coordinator: {
      get () {
        return this.job.coordinator_id
      },

      set (value) {
        let coordinator = find(this.users, user => user.id === value)

        this[SET_JOB_ATTRIBUTE]({ attribute: 'coordinator', value: coordinator })
        this[SET_JOB_ATTRIBUTE]({ attribute: 'coordinator_id', value })
      }
    },

    startAt: {
      get () {
        return this.job.start_at
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'start_at', value })
      }
    },

    endAt: {
      get () {
        return this.job.end_at
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'end_at', value })
      }
    },

    quantity: {
      get () {
        return this.job.quantity
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'quantity', value })
      }
    },
    commissionAmount: {
      get () {
        return this.job.commission_amount
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'commission_amount', value })
      }
    },

    commodity: {
      get () {
        return this.job.commodity_id
      },

      set (id) {
        let commodity = find(this.commodities, commodity => commodity.id === id)

        this[SET_JOB_ATTRIBUTE]({ attribute: 'commodity', value: commodity })
        this[SET_JOB_ATTRIBUTE]({ attribute: 'commodity_id', value: id })
      }
    },

    orderReference: {
      get () {
        return this.job.order_reference
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'order_reference', value })
      }
    },

    pickupReference: {
      get () {
        return this.job.pickup_reference
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'pickup_reference', value })
      }
    },

    deliveryReference: {
      get () {
        return this.job.delivery_reference
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'delivery_reference', value })
      }
    },

    locationFrom: {
      get () {
        return this.job.location_from_id
      },

      set (value) {
        let location = isObject(value) ? value : (find(this.locationsFrom, location => location.id === value) || null)
        let id = isObject(location) ? location.id : null

        this[SET_JOB_ATTRIBUTE]({ attribute: 'location_from', value: location })
        this[SET_JOB_ATTRIBUTE]({ attribute: 'location_from_id', value: id })
      }
    },

    locationTo: {
      get () {
        if (this.job.location_to) {
          return this.job.location_to.id
        }

        return null
      },

      set (value) {
        let location = isObject(value) ? value : (find(this.locationsTo, location => location.id === value) || null)
        let id = isObject(location) ? location.id : null

        this[SET_JOB_ATTRIBUTE]({ attribute: 'location_to', value: location })
        this[SET_JOB_ATTRIBUTE]({ attribute: 'location_to_id', value: id })
      }
    },

    rate: {
      get () {
        return this.job.rate
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'rate', value })
      }
    },

    requestPrice: {
      get () {
        return this.job.request_price
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'request_price', value })
      }
    },

    notes: {
      get () {
        return this.job.notes
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'notes', value })
      }
    },

    notifyJobStatus: {
      get () {
        return this.job.notify_job_status
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'notify_job_status', value })
      }
    },

    notifyLoadDeliveries: {
      get () {
        return this.job.notify_load_deliveries
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'notify_load_deliveries', value })
      }
    },

    notifyJobCompleted: {
      get () {
        return this.job.notify_job_completed
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'notify_job_completed', value })
      }
    },

    notifyChildren: {
      get () {
        return this.job.notify_children
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'notify_children', value })
      }
    },

    publicJob: {
      get () {
        return this.job.public
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'public', value })
      }
    },

    publicQuantity: {
      get () {
        return this.job.public_quantity
      },

      set (value) {
        this[SET_JOB_ATTRIBUTE]({ attribute: 'public_quantity', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jobs/state-mapper.js